var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"page"},[_c('div',[_c('h2',[_vm._v("\n                Using emojis\n            ")]),_c('p',[_vm._v("\n                To use emojis, simply tap the icon to open the emoji selection menu. To switch back to your\n                keyboard, tap the icon.\n            ")])])])])
}]

export { render, staticRenderFns }